export default __webpack_public_path__ + "68226def41067e5ebeedccf23d37db45.svg";